module.exports = __webpack_public_path__ + "static/media/waiting.2761b5d3.png";